"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes in a list of classnames as arguments and compiles them into a single string with each classname separated by a space.
 * @param classes
 * @returns a string of combined classnames
 */
const joinClassNames = (...classes) => classes.filter((className) => className).join(' ');
exports.default = joinClassNames;
//# sourceMappingURL=joinClassNames.js.map